import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Chat from    '@/components/Chat'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/chat',
      name: 'Chat',
      component: Chat,
      props: true, // this accepts props which is the (name of user on welcome screen when the enter the chat room)
      //this is a route gaurd to block users from accessing the chat component in the url take 3 arguments
      beforeEnter:(to, from, next)=>{
        if(to.params.name){
           next()
        }else{
          next({name: 'Welcome'})
        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js